var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.136719,
    y: 0.5625,
    width: 40.8755,
    height: 40.8755,
    rx: 18.0288,
    fill: "#E8C229",
    fillOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.30766,
    transform: "matrix(-1 0 0 1 20.6923 16.9122)",
    fill: "#E8C229",
    stroke: "#E8C229",
    strokeWidth: 1.24037
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9023 25.1267C14.9023 24.4152 15.3496 23.7806 16.0196 23.5413C19.0403 22.4625 22.3412 22.4625 25.3619 23.5413C26.0319 23.7806 26.4792 24.4152 26.4792 25.1267V26.2145C26.4792 27.1964 25.6095 27.9507 24.6374 27.8118L23.8482 27.6991C21.7539 27.3999 19.6276 27.3999 17.5333 27.6991L16.7441 27.8118C15.772 27.9507 14.9023 27.1964 14.9023 26.2145V25.1267Z",
    fill: "#E8C229",
    stroke: "#E8C229",
    strokeWidth: 1.24037
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6ce1af9b77b310c5f6c785dfc29e11d8.svg";
export { ForwardRef as ReactComponent };